import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon } from 'lucide-react';
interface CtaButtonProps {
  label?: string;
  showCuotas?: boolean;
  showPaymentSeal?: boolean;
  showTrustSignals?: boolean;
  checkout?: boolean;
  subtitle?: string;
  large?: boolean;
}
export function CtaTrustSignals() {
  return <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs font-medium text-neutral-500" data-id="element-53" data-mp="cjzpi1q65n87">
      <span className="flex items-center gap-1" data-id="element-54" data-mp="qiqw732pc6mb"><ZapIcon className="h-3.5 w-3.5 text-orange-600" data-id="element-55" data-mp="lm0kerxxjx6p" /> Acceso inmediato</span>
      <span className="flex items-center gap-1" data-id="element-56" data-mp="10adhjs8r7m2s"><LockIcon className="h-3.5 w-3.5 text-orange-600" data-id="element-57" data-mp="109bvksq79f6a" /> Pago seguro</span>
      <span className="flex items-center gap-1" data-id="element-58" data-mp="vaqu6pz7opg9">🛡️ Garantía 7 días</span>
    </div>;
}
export function PaymentSeal() {
  return <div className="mt-4 flex justify-center" data-id="element-59" data-mp="19c386vutagzi">
      <img src="https://cdn.magicpatterns.com/uploads/pWoCPekSYcazdCDvugwUjT/pasted-image.jpg" alt="Mercado Pago, tarjetas y compra 100% segura con SSL" loading="lazy" decoding="async" className="h-32 w-auto max-w-full rounded-lg bg-white object-contain p-1" data-id="element-60" data-mp="198p3hgyodvow" />
    </div>;
}
export function CtaButton({
  label = 'SÍ, QUIERO LAS 250 RECETAS Y LOS 5 BONOS',
  showCuotas = true,
  showPaymentSeal = false,
  showTrustSignals = true,
  checkout = false,
  subtitle,
  large = false
}: CtaButtonProps) {
  const destination = checkout ? 'https://megapackairfryargentina.impultienda.ar/' : '#oferta-principal';
  const ariaLabel = checkout ? 'Ir al checkout seguro del MegaPack' : 'Ir a la oferta principal del MegaPack';
  return <div className="mx-auto w-full max-w-xl" data-id="element-61" data-mp="1j7nom9uco7n">
      {showCuotas && <div className="mb-3 flex justify-center" data-id="element-62" data-mp="1l0zsh3840n1">
          <span className="inline-flex items-center gap-2 rounded-full bg-orange-100 px-4 py-1.5 text-sm font-bold text-orange-900" data-id="element-63" data-mp="6iamhoz89y76">
            <ZapIcon className="h-4 w-4" data-id="element-64" data-mp="bios70dcww21" /> En hasta 3 cuotas · Acceso inmediato
          </span>
        </div>}
      <motion.a href={destination} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} animate={{
      scale: [1, 1.01, 1]
    }} transition={{
      scale: {
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} aria-label={ariaLabel} className={`group flex w-full flex-col items-center justify-center rounded-2xl bg-orange-600 px-6 text-center shadow-[0_12px_28px_-8px_rgba(234,88,12,0.75)] transition-colors hover:bg-orange-700 ${large ? 'min-h-[76px] py-5 sm:min-h-[86px] sm:py-6' : 'py-5'}`} data-id="element-65" data-mp="gggos7oy56ck">
        <span className={`font-extrabold uppercase leading-tight tracking-tight text-white ${large ? 'text-lg sm:text-2xl' : 'text-lg sm:text-2xl'}`} data-id="element-66" data-mp="4ig0f9kghf7n">
          {label}
        </span>
      </motion.a>
      {subtitle && <p className="mt-2 text-center text-sm font-bold text-white" data-id="element-67" data-mp="eiyqim2m5ry0">{subtitle}</p>}
      {showTrustSignals && <CtaTrustSignals data-id="element-68" data-mp="2l8wo8phi7h8h" />}
      {showPaymentSeal && <PaymentSeal data-id="element-69" data-mp="2g90iakp8xfqa" />}
    </div>;
}